import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="select2modal"
// Attach to a wrapper div containing the <select data-select2modal-target="select">
export default class extends Controller {
  static targets = ["select"]

  connect() {
    this.buildDropdown()
  }

  disconnect() {
    if (this.wrapper) this.wrapper.remove()
  }

  buildDropdown() {
    const select = this.selectTarget
    select.style.display = 'none'

    this.wrapper = document.createElement('div')
    this.wrapper.classList.add('dropdown')
    this.wrapper.style.width = '100%'

    // Toggle button
    this.toggle = document.createElement('button')
    this.toggle.type = 'button'
    this.toggle.classList.add('btn', 'btn-outline-secondary', 'btn-sm', 'dropdown-toggle', 'w-100', 'text-start')
    this.toggle.setAttribute('data-bs-toggle', 'dropdown')
    this.toggle.setAttribute('aria-expanded', 'false')
    this.toggle.textContent = select.options[select.selectedIndex]?.text || 'Select...'

    // Dropdown menu
    this.menu = document.createElement('div')
    this.menu.classList.add('dropdown-menu', 'p-2', 'w-100')
    this.menu.style.maxHeight = '250px'
    this.menu.style.overflowY = 'auto'

    // Search input
    const input = document.createElement('input')
    input.type = 'text'
    input.classList.add('form-control', 'form-control-sm', 'mb-2')
    input.placeholder = 'Search...'
    input.addEventListener('input', () => this.filter(input.value))
    input.addEventListener('click', (e) => e.stopPropagation())
    this.menu.appendChild(input)

    // Build items from select options
    Array.from(select.options).forEach((option, index) => {
      if (index === 0 && option.selected) return // skip placeholder
      const item = document.createElement('a')
      item.classList.add('dropdown-item')
      item.href = '#'
      item.textContent = option.text
      item.dataset.value = option.value
      item.addEventListener('click', (e) => {
        e.preventDefault()
        this.selectOption(option.value, option.text)
      })
      this.menu.appendChild(item)
    })

    this.wrapper.appendChild(this.toggle)
    this.wrapper.appendChild(this.menu)
    select.parentNode.insertBefore(this.wrapper, select.nextSibling)
  }

  filter(query) {
    const value = query.toLowerCase()
    this.menu.querySelectorAll('.dropdown-item').forEach(item => {
      item.style.display = item.textContent.toLowerCase().includes(value) ? '' : 'none'
    })
  }

  selectOption(value, text) {
    this.selectTarget.value = value
    this.toggle.textContent = text
  }
}
